'use strict';

exports.__esModule = true;

var _chunk2 = require('lodash/chunk');

var _chunk3 = _interopRequireDefault(_chunk2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _dropdown = require('dropdown');

var _starRating = require('star-rating');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROW_SIZE = 2;
var CONTENT_TYPES = ['reviews', 'recommendations'];
var PROFILE_TYPES = ['specialist', 'practice'];

/**
 * Returns true if the type is any of the valid types.
 * @param {string} type The type.
 * @param {!Array<string>} validTypes The valid types.
 * @return {boolean} True if the type is valid.
 */
var isValidType = function isValidType(type, validTypes) {
	return !!type && validTypes.includes(type);
};

/**
 * Returns the rating with a decimal place, or 0.0 if the rating is invalid.
 * @param {number} rating The rating.
 * @return {number} The rating with a decimal place.
 */
var formatRating = function formatRating(rating) {
	return rating && rating.toFixed(1) || '0.0';
};

/**
 * Formats the children so that single values are transformed into a
 * single-value array, or an empty array if no values are provided.
 * @param {!Object} children The component's children.
 * @return {!Array} The component's children.
 */
var formatChildren = function formatChildren(children) {
	return (0, _isArray3.default)(children) ? children : children && [children] || [];
};

var _ref = _react2.default.createElement('i', { className: 'ion-arrow-left-c' });

var _ref2 = _react2.default.createElement('i', { className: 'ion-arrow-right-c' });

var WidgetCarousel = function WidgetCarousel(props) {
	return isValidType(props.contentType, CONTENT_TYPES) && isValidType(props.profileType, PROFILE_TYPES) && _react2.default.createElement(
		'div',
		{ className: props.className },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.header },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.titleContainer },
				_react2.default.createElement(
					'div',
					{ className: _style2.default.title },
					_react2.default.createElement(
						'span',
						{ className: props.title || !props.subtitle && props.contentType ? _style2.default.highlighted : '' },
						props.title && props.title.trim() || !props.subtitle && props.contentType
					),
					' ',
					props.subtitle && props.subtitle.trim()
				),
				_react2.default.createElement(
					'div',
					{ className: _style2.default.description },
					_react2.default.createElement(
						'div',
						{ className: _style2.default.totalReviews },
						props.totalReviews,
						' ',
						props.totalReviews !== 1 ? 'reviews' : 'review'
					),
					props.showSpecialistRating && _react2.default.createElement(
						'div',
						{ className: _style2.default.averageRating },
						_react2.default.createElement(_starRating.StarRating, { className: _style2.default.stars, averageRating: props.averageRating }),
						_react2.default.createElement(
							'span',
							{ className: _style2.default.starsLabel },
							'(',
							formatRating(props.averageRating),
							')'
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.rightSideContainer },
				props.profileType === 'practice' && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_starRating.StarRating, { className: _style2.default.stars, averageRating: props.averageRating }),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.starsLabel },
						formatRating(props.averageRating)
					)
				),
				props.profileType === 'specialist' && props.dropdownItems && props.dropdownItems.length > 0 && _react2.default.createElement(
					'div',
					{ className: _style2.default.dropdownContainer },
					_react2.default.createElement(_dropdown.Dropdown, {
						className: _style2.default.specialistsDropdown,
						items: props.dropdownItems,
						selectedItem: props.selectedSpecialist,
						onItemSelected: props.onSpecialistSelected,
						onTextChanged: props.onSpecialistTextChanged,
						placeholder: 'All specialists',
						ItemRenderer: function ItemRenderer(rendererProps) {
							var item = rendererProps.item,
							    nameTransform = rendererProps.nameTransform;

							return _react2.default.createElement(
								'div',
								{ className: '' + _style2.default.dropdownItem },
								item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
								_react2.default.createElement(
									'span',
									null,
									nameTransform(item)
								)
							);
						} })
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.bodyContainer },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.arrowButtonContainer },
				props.showPreviousButton && _react2.default.createElement(
					'button',
					{ className: _style2.default.arrowButton + ' ' + _style2.default.previousButton, onClick: props.onPreviousButtonClick },
					_ref
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.contentContainer },
				(0, _chunk3.default)(formatChildren(props.children), props.rowSize).map(function (row, rowIndex) {
					return _react2.default.createElement(
						'div',
						{ key: rowIndex, className: _style2.default.row + ' row' },
						row.map(function (element, columnIndex) {
							return _react2.default.createElement(
								'div',
								{ key: columnIndex, className: _style2.default.column + ' ' + (props.rowSize === ROW_SIZE ? 'col-sm-6' : 'col-sm-3') },
								element
							);
						})
					);
				}).reduce(function (newArray, row) {
					return [].concat(newArray, row);
				}, [])
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.arrowButtonContainer },
				props.showNextButton && _react2.default.createElement(
					'button',
					{ className: _style2.default.arrowButton + ' ' + _style2.default.nextButton, onClick: props.onNextButtonClick },
					_ref2
				)
			)
		)
	) || null;
};

WidgetCarousel.propTypes = {
	contentType: require('react').PropTypes.any.isRequired,
	profileType: require('react').PropTypes.any.isRequired,
	title: require('react').PropTypes.any.isRequired,
	subtitle: require('react').PropTypes.any.isRequired,
	totalReviews: require('react').PropTypes.any,
	averageRating: require('react').PropTypes.any,
	showSpecialistRating: require('react').PropTypes.any,
	showPreviousButton: require('react').PropTypes.any,
	showNextButton: require('react').PropTypes.any,
	onPreviousButtonClick: require('react').PropTypes.func,
	onNextButtonClick: require('react').PropTypes.func,
	rowSize: require('react').PropTypes.any,
	children: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	className: require('react').PropTypes.any,
	noRating: require('react').PropTypes.any,
	dropdownItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
	selectedSpecialist: require('react').PropTypes.object,
	onSpecialistSelected: require('react').PropTypes.func,
	onSpecialistTextChanged: require('react').PropTypes.func,
	disableNextButton: require('react').PropTypes.any,
	disablePreviousButton: require('react').PropTypes.any
};
WidgetCarousel.displayName = 'WidgetCarousel';

WidgetCarousel.defaultProps = {
	totalReviews: 0,
	averageRating: 0.0,
	showSpecialistRating: false,
	showPreviousButton: false,
	showNextButton: false,
	rowSize: ROW_SIZE,
	children: [],
	noRating: false
};

exports.default = WidgetCarousel;